import {
  Avatar,
  Grid,
  Button as MaterialButton,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import clsx from "clsx";
import { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { logout } from "../../auth/actions/logout.actions";
import { CustomDropdown } from "../../common/custom-dropdown";
import { Participant } from "../../models/api/participant";
import { useHistory } from "../../shared/hooks/useHistory";
import { LogoutIcon } from "../../shared/icons";
import { Button } from "../Button";
import { myResourcesOptions } from "../drawer-menu/utils";
import { useStyles } from "./financial-profile.styles";

interface ProfileSectionProps {
  isMobile?: boolean;
  participantProfile: Participant;
  handleClose: () => void;
  setScreen?: (screen: string[]) => void;
}

export const ProfileSection = ({
  participantProfile,
  handleClose,
  isMobile,
  setScreen,
}: ProfileSectionProps) => {
  const menuRef = useRef();
  const dispatch = useDispatch();
  const [isDropdownMenuOpen, setDropdownMenuOpen] = useState(false);
  const classes = useStyles({});
  const history = useHistory();

  const toggleDropdownMenu = () => {
    setDropdownMenuOpen(!isDropdownMenuOpen);
    handleClose();
  };

  const handleLogoutClick = () => {
    dispatch(logout());
  };

  const onMyResourcesClicked = () => {
    if (isMobile) {
      setScreen(["myResources"]);
    } else {
      setDropdownMenuOpen(true);
    }
  };

  const handleProfileClick = () => {
    history.push("/participant/participantProfile");
    handleClose();
  };

  const displayButtonOptions = (
    <>
      <div className={classes.menuActions}>
        <Button
          data-testid="profile-button"
          variant="contained"
          onClick={handleProfileClick}
          className={clsx({ [classes.myProfile]: isMobile })}
        >
          My Profile
        </Button>
        <Button
          data-testid="resources-button"
          variant="outlined"
          onClick={onMyResourcesClicked}
          aria-controls="basic-menu"
          aria-haspopup="true"
          className={classes.resourcesButton}
          endIcon={!isMobile ? <ExpandMoreIcon /> : undefined}
          ref={menuRef}
        >
          My Resources
        </Button>
      </div>
      <MaterialButton
        onClick={handleLogoutClick}
        className={classes.logoutButton}
        startIcon={<LogoutIcon className={classes.logOutIcon} />}
      >
        Log out
      </MaterialButton>
    </>
  );

  return (
    <>
      <Grid
        item
        md={3}
        xs={!isMobile ? 3 : 12}
        className={clsx({ [classes.flexCenter]: isMobile })}
        data-testid="profile-section"
      >
        <Avatar
          data-testid="avatar-icon"
          className={classes.avatar}
          alt={participantProfile?.name}
          src={participantProfile?.profilePicturePath}
        />
        {isMobile && (
          <Typography
            variant="h6"
            className={classes.title}
            data-testid="profile-name-mobile"
          >
            {participantProfile.name}
          </Typography>
        )}
      </Grid>

      {!isMobile && (
        <Grid item xs={9} data-testid="profile-desktop-mode">
          <Typography variant="h6" className={classes.title}>
            {participantProfile.name}
          </Typography>

          {displayButtonOptions}

          <CustomDropdown
            options={myResourcesOptions}
            open={isDropdownMenuOpen}
            anchorEl={menuRef.current}
            handleClose={toggleDropdownMenu}
            handleClick={toggleDropdownMenu}
          />
        </Grid>
      )}

      {isMobile && (
        <Grid item xs={12}>
          {displayButtonOptions}
        </Grid>
      )}
    </>
  );
};
